import { toArray, qsa } from './domUtils';

export interface EditItem {
  selector: string;
  fn: (el: HTMLElement) => void;
}

export const editHtml = (
  html: string,
  edit: EditItem[] = [],
  isStripParagraphs: boolean = false,
) => {
  const el = document.createElement('div');
  el.innerHTML = html;

  if (isStripParagraphs) {
    stripParagraphs(el);
  }

  edit.forEach((e) => qsa(e.selector, el).forEach((item) => e.fn(item)));

  return el.innerHTML;
};

export const stripParagraphs = (el: HTMLElement) => {
  let html = '';
  toArray(el.childNodes).forEach((c) => {
    const tag = c as HTMLElement;

    if (tag.tagName) {
      if (tag.tagName.toLowerCase() === 'p') {
        html += tag.innerHTML;
      } else {
        html += tag.outerHTML;
      }
    } else {
      const text = c as Text;
      if (text) html += text.textContent ? text.textContent.trim() : '';
    }
  });
  el.innerHTML = html;
};

export const makeDropLetter = (html: string) => {
  return editHtml(
    html,
    [{ selector: 'p:first-of-type', fn: (p) => (p.className = 'text--first-letter') }],
    false,
  );
};
